import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const communitiesTableTooltips = TOOLTIPS_TEXTS.communitiesTable;

export const COMMUNITIES_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const COMMUNITIES_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const COMMUNITIES_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'division', 'city', 'state', 'options'],
  displayedTitles: ['Name', 'Division', 'City', 'State/Province', 'Actions'],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    communitiesTableTooltips.name,
    communitiesTableTooltips.division,
    communitiesTableTooltips.city,
    communitiesTableTooltips.state
  ],
  options: null,
  dataSource: []
};
